import React from 'react';
import { styled } from '@linaria/react';

import { GridStructure as BaseGridStructure } from './Grid.shared';

function GridAreasStructure({
  withLabels,
}: {
  withLabels?: boolean;
}) {
  return (
    <GridStructure>
      <GridRow />
      <GridColumn />
      <HeaderArea>
        <BaseBlock>Header</BaseBlock>
      </HeaderArea>
      <MainArea>
        <BaseBlock>Main</BaseBlock>
      </MainArea>
      <SidebarArea>
        <BaseBlock>
          <SidebarText>Sidebar</SidebarText>
        </BaseBlock>
      </SidebarArea>
      {withLabels && (
        <>
          <ColLabel style={{ gridRow: 1, gridColumn: 1 }}>
            2fr
          </ColLabel>
          <ColLabel style={{ gridRow: 1, gridColumn: 2 }}>
            5fr
          </ColLabel>
          <RowLabel style={{ gridRow: 1, gridColumn: 1 }}>
            50px
          </RowLabel>
          <RowLabel style={{ gridRow: 2, gridColumn: 1 }}>
            1fr
          </RowLabel>
        </>
      )}
    </GridStructure>
  );
}

const GridStructure = styled(BaseGridStructure)`
  grid-template-columns: 2fr 5fr;
  grid-template-rows: 50px 1fr;
  gap: 6px;
  padding: 2px;
`;

const GridRow = styled.div`
  grid-row: 1;
  grid-column: 1 / -1;
  border: 1px solid transparent;
  border-bottom: 2px dashed var(--color-gray-500);
  transform: translateY(4px);
`;

const GridColumn = styled.div`
  grid-row: 1 / -1;
  grid-column: 1;
  border: 1px solid transparent;
  border-right: 2px dashed var(--color-gray-500);
  transform: translateX(4px);
`;

const BaseArea = styled.div`
  padding: 2px;
`;
const HeaderArea = styled(BaseArea)`
  grid-row: 1;
  grid-column: 2;
`;
const MainArea = styled(BaseArea)`
  grid-row: 2;
  grid-column: 2;
`;
const SidebarArea = styled(BaseArea)`
  grid-row: 1 / 3;
  grid-column: 1;
`;

const BaseBlock = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  border-radius: 4px;
  background: var(--color-gray-200);
  color: var(--color-gray-800);
  text-transform: uppercase;
  font-size: 1.75rem;
  font-weight: bold;
  opacity: 0.8;
  letter-spacing: 0.5px;
`;

const SidebarText = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  transform-origin: center center;
  height: 1rem;
  line-height: 1rem;
`;

const Label = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  font-style: italic;
  user-select: none;

  &::after {
    content: '';
    position: absolute;
    border: 2px solid white;
  }

  /*
    The row labels don't fit on mobile.
    If I add padding there, then the entire grid doesn't fit
    comfortably. So we'll hide the labels on mobile, since they
    aren't actually 100% necessary.
  */
  @media (max-width: 29rem) {
    display: none;
  }
`;

const ColLabel = styled(Label)`
  align-self: start;
  transform: translateY(calc(-100% - 12px));

  &::after {
    left: 0px;
    right: 0px;
    bottom: -4px;
    height: 4px;
    border-bottom: none;
    border-radius: 8px 8px 2px 2px;
  }
`;

const RowLabel = styled(Label)`
  justify-self: start;
  flex-direction: column;
  transform: translateX(calc(-100% - 12px));
  padding-right: 10px;

  &::after {
    top: 0px;
    right: -4px;
    bottom: 0px;
    width: 4px;
    border-right: none;
    border-radius: 8px 2px 2px 8px;
  }
`;

export default GridAreasStructure;
